import { Component, OnInit } from '@angular/core';
import { AppComponent } from './app.component';
import { AppMainComponent } from './app.main.component';
import { UserService } from './services/user.service';

@Component({
    selector: 'app-topbar',
    template: `
        <div class="layout-topbar">
            <div class="layout-topbar-wrapper">
                <div class="layout-topbar-left">
                    <div class="layout-topbar-logo flex align-items-center" id="logolink" style="cursor: pointer; outline: none;" routerLink="/">
                        <img id="app-logo"
                             [src]="'assets/images/tsphere-logo.svg'">
                    </div>
                </div>

                <div class="layout-topbar-right flex align-items-center">
                    <a class="menu-button" href="#" (click)="appMain.onMenuButtonClick($event)">
                        <i class="pi pi-bars"></i>
                    </a>
                    <ul class="layout-topbar-actions">
                        
                        <li #profile class="topbar-item user-profile"
                            [ngClass]="{'active-topmenuitem':appMain.activeTopbarItem === profile}">
                            <a href="#" (click)="appMain.onTopbarItemClick($event,profile)">
                                    <div class="flex align-items-center justify-content-center text-xl">{{userName}}</div>
                            </a>
                        </li>
                        <li #profile class="topbar-item user-profile"
                            [ngClass]="{'active-topmenuitem':appMain.activeTopbarItem === profile}">
                            <button pButton pRipple label="Logout" style="color:#515C66;background-color: #E8F1F8;border-color:#E8F1F8 ;" (click)="logout()"> </button>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    `
})
export class AppTopBarComponent implements OnInit {

    userName!: string

    constructor(public appMain: AppMainComponent, public app: AppComponent, private userService: UserService) {
    }

    ngOnInit(): void {
        this.userName = this.userService.getUserFromMsal()
    }

    logout() {
        this.userService.logout()
    }



}
